import { motion } from 'framer-motion';
import { useLanguage } from '../../providers/language_provider';
import { Button } from '../common/Button';
import { useInView } from 'react-intersection-observer';

export function Hero() {
  const { content } = useLanguage();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <div className="relative min-h-screen hero-background bg-fixed bg-cover bg-center">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      
      <motion.div
        ref={ref}
        variants={containerVariants}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        className="relative flex items-center justify-center min-h-screen px-4 sm:px-6 lg:px-8"
      >
        <div className="text-center max-w-3xl mx-auto">
          <motion.h1
            variants={itemVariants}
            className="text-4xl sm:text-6xl font-bold font-caprice tracking-tight bg-gradient-to-r from-blue-400 via-green-300 to-yellow-400 text-transparent bg-clip-text mb-6"
          >
            {content.heroTitle}
          </motion.h1>

          <motion.p
            variants={itemVariants}
            className="text-lg sm:text-xl text-gray-300 mb-8 leading-relaxed tracking-wide"
          >
            {content.heroSubtitle}
          </motion.p>

          <motion.div variants={itemVariants}>
            <Button
              text={content.toContact}
              to="/contact"
              size="lg"
              className="shadow-lg shadow-primary-500/20"
            />
          </motion.div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.6 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <div className="animate-bounce">
          <svg
            className="w-6 h-6 text-white"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </div>
      </motion.div>
    </div>
  );
}